import React, { ReactElement, useCallback, useEffect, useState } from 'react';
import { Row, Typography, Upload, Layout, Modal } from 'antd';
import { useParams } from 'react-router-dom';
import { S3 } from 'aws-sdk';
import { RcFile, UploadFile } from 'antd/lib/upload/interface';
import { setAWSCreds } from '../../../../utils/accessToken';
import { readWebsiteVariable } from '../../../../utils/readWebsiteVariable';

const { Text } = Typography;
const { Content } = Layout;

const OrganizationSettingsTab = (): ReactElement => {
  const { accountId } = useParams<{ accountId: string; tabId?: string }>();
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewVisible, setPreviewVisible] = useState(false);
  const domain = readWebsiteVariable('REACT_APP_api_domain')?.substring(4);
  const getBucketName = useCallback(() => {
    return domain.includes('ca.')
      ? `${domain.replace('ca.', '')}-env-assets-ca-central-1`
      : `${domain}-env-assets`;
  }, [domain]);
  const loadLogo = useCallback(async () => {
    await setAWSCreds();
    const s3 = new S3();
    s3.getObject({
      Bucket: getBucketName(),
      Key: accountId
    })
      .promise()
      .then((result) => {
        setFileList([
          {
            type: 'image/png',
            name: 'test',
            size: result.ContentLength ?? 0,
            uid: 'test',
            thumbUrl:
              'data:image/png;base64,' + result?.Body?.toString('base64')
          }
        ]);
      })
      .catch((error) => {
        // No file throws Access Denied. We're suppressing that exception.
        if (error.message !== 'Access Denied') {
          throw error;
        }
      });
  }, [accountId, getBucketName]);

  const onChange = (file: RcFile) => {
    setFileList([
      {
        name: file.name,
        size: file.size,
        type: 'image/png',
        uid: file.name,
        status: 'uploading'
      }
    ]);
    const s3 = new S3();
    s3.upload({
      Bucket: getBucketName(),
      Key: accountId,
      Body: file
    })
      .promise()
      .then((result) => {
        loadLogo();
      });

    return false;
  };

  const onPreview = async (file: UploadFile) => {
    setPreviewVisible(true);
  };

  const closePreview = () => setPreviewVisible(false);

  const onRemove = (file: UploadFile) => {
    const s3 = new S3();
    s3.deleteObject({
      Bucket: `${domain}-env-assets`,
      Key: accountId
    })
      .promise()
      .then((result) => {
        setFileList([]);
      });
  };

  useEffect(() => {
    loadLogo();
  }, [accountId, loadLogo]);
  return (
    <Content style={{ padding: '24px' }}>
      <Row>
        <Text>Your Logo</Text>
      </Row>
      <Row>
        <Text type="secondary">
          Used for white-labeling various parts of the notifications such as
          unsubscribe confirmation pages.
        </Text>
      </Row>
      <Row
        style={{
          marginTop: '24px'
        }}
      >
        <Upload
          fileList={fileList}
          listType="picture-card"
          onPreview={onPreview}
          onRemove={onRemove}
          beforeUpload={onChange}
        >
          {fileList.length === 0 ? '+ Upload' : '+ Change'}
        </Upload>
      </Row>
      <Row>
        <Text type="secondary">Use a high resolution png.</Text>
      </Row>
      <Modal
        open={previewVisible}
        title="Logo"
        footer={null}
        onCancel={closePreview}
      >
        <img alt="logo" style={{ width: '100%' }} src={fileList[0]?.thumbUrl} />
      </Modal>
    </Content>
  );
};

export default OrganizationSettingsTab;
